/** Light-mode toggle helper. Persists to localStorage. */

const KEY = "wm-theme";

export type Theme = "dark" | "light";

export function getTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme) || "dark";
}

export function setTheme(t: Theme) {
  localStorage.setItem(KEY, t);
  document.documentElement.dataset.theme = t;
}

export function applyTheme() {
  document.documentElement.dataset.theme = getTheme();
}

export function toggleTheme(): Theme {
  const next = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
